import { mdiMap } from '@mdi/js'

export default {
  title: 'Location',
  to: 'location-list',
  icon: mdiMap,
  resource: 'Location',
  action: 'read',
}
